const initialAccountExtraitTransactionListFilters = { pageSize: 10, pageOffset: 0 };

const defaultAccountDetailsState = {
  checkAuthorizationData: null,
  selectedAccountDetails: null,
  selectedAccount: null,
  onAccountSelect: (
    propertyValue: string | number,
    propertyName: 'accountNumber' | 'accountId' = 'accountNumber',
  ) => {},
  onTransactionListFiltersChange: () => {},
  onResetTransactionListFilters: () => {},
  accountExtraitTransactionListFilters: initialAccountExtraitTransactionListFilters,
  onRefetchAccountDetails: () => {},
  onRefetchAccountExtraitTransactionList: () => {},
  loadingState: {
    isLoadingAccountDetails: false,
    isLoadingAccountExtraitTransactionList: false,
  },
  errorState: {
    accountDetailsError: undefined,
    accountExtraitTransactionListError: undefined,
  },
  lastPaginationPageVisited: 1,
  onSetLastPaginationPageVisited: (value: number) => {},
};

export { defaultAccountDetailsState, initialAccountExtraitTransactionListFilters };
